import React, { Component, useEffect, useState } from "react";

import { makeStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import Typography from '@material-ui/core/Typography';
import Background from '../img/other/quiz.png';

import UserService from "../services/user.service";
import AuthService from "../services/auth.service";
import {socket} from '../socket';

import TextContainer from './TextContainer/TextContainer';

const ENDPOINT = 'http://localhost:5000/';

const BoardUser = () => {
  const [name, setName] = useState('');
  const [room, setRoom] = useState('');
  const [users, setUsers] = useState('');
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [content,setContent] =  useState('');
  useEffect(() => {
    //const { name, room } = queryString.parse(location.search);

    const name=  AuthService.getCurrentUser().username;
    const room = 'AgedCare';

    setRoom(room);
    setName(name)

    socket.emit('join', { 'name':name, 'room':room }, (error) => {
      if(error) {
        // alert(error);
      }
    });
  }, []);
  
  useEffect(() => {
    socket.on('message', message => {
      setMessages(messages => [ ...messages, message ]);
    });
    
    socket.on("roomData", ({ users }) => {
      setUsers(users);
    });
}, []);

  const sendMessage = (message) => {
    
    if(message) {
      socket.emit('sendMessage', message, () => setMessage(''));
    }
  }

  useEffect( () => {
    UserService.getUserBoard().then(
      response => {
        setContent(response.data);
        
      },
      error => {
        setContent ('unauthorized');
      }
    );
  }

  ,[]);



  const handleClick = (id) => {
    if (id == "Music")
    {
      sendMessage('{"api":"music", "action":"start","file":"random", "motion":"DBlues1"}');
    }else if (id == "Book")
    {
      sendMessage('{"api":"book", "action":"start","file":"random", "background":"no","soundeffect":"yes"}');
    }else
    {
      sendMessage('{"api":"music", "action":"stop","file":"random", "motion":"DBlues1"}');
      sendMessage('{"api":"book", "action":"stop","file":"random", "background":"no","soundeffect":"yes"}');
    }
    
  }
 
 const images = [
   {
     url:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmvfaVRjOK2TPTOwgERFrbfSDfV49Rq_GNoQ&usqp=CAU',
     title: 'Music',
     width: '30%',
   },
   {
     url: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTtyUE8LZfB30wRXvmWMJi6YcbQvieztH1FeQ&usqp=CAU',
     title: 'Book',
     width: '30%',
   },
   {
     url: '',
     title: 'Stop',
     width: '30%',
   },
 ];
 
 const useStyles = makeStyles((theme) => ({
   root: {
     display: 'flex',
     flexWrap: 'wrap',
     minWidth: 300,
     width: '100%',
   },
   image: {
     position: 'relative',
     height: 200,
     [theme.breakpoints.down('xs')]: {
       width: '100% !important', // Overrides inline-style
       height: 100,
     },
     '&:hover, &$focusVisible': {
       zIndex: 1,
       '& $imageBackdrop': {
         opacity: 0.15,
       },
       '& $imageMarked': {
         opacity: 0,
       },
       '& $imageTitle': {
         border: '4px solid currentColor',
       },
     },
   },
   focusVisible: {},
   imageButton: {
     position: 'absolute',
     left: 0,
     right: 0,
     top: 0,
     bottom: 0,
     display: 'flex',
     alignItems: 'center',
     justifyContent: 'center',
     color: theme.palette.common.white,
   },
   imageSrc: {
     position: 'absolute',
     left: 0,
     right: 0,
     top: 0,
     bottom: 0,
     backgroundSize: 'cover',
     backgroundPosition: 'center 40%',
   },
   imageBackdrop: {
     position: 'absolute',
     left: 0,
     right: 0,
     top: 0,
     bottom: 0,
     backgroundColor: theme.palette.common.black,
     opacity: 0.4,
     transition: theme.transitions.create('opacity'),
   },
   imageTitle: {
     position: 'relative',
     padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${theme.spacing(1) + 6}px`,
   },
   imageMarked: {
     height: 3,
     width: 18,
     backgroundColor: theme.palette.common.white,
     position: 'absolute',
     bottom: -2,
     left: 'calc(50% - 9px)',
     transition: theme.transitions.create('opacity'),
   },
 }));
 
 
   const classes = useStyles();
   if (content!='unauthorized')
   {
   return (
     <div className={classes.root}>
       {images.map((image) => (
         <ButtonBase onClick={() => { handleClick(image.title); }}
           focusRipple
           key={image.title}
           className={classes.image}
           focusVisibleClassName={classes.focusVisible}
           style={{
             width: image.width,
           }}
         >
           <span
             className={classes.imageSrc}
             style={{
               backgroundImage: `url(${image.url})`,
             }}
           />
           <span className={classes.imageBackdrop} />
           <span className={classes.imageButton}>
             <Typography
               component="span"
               variant="subtitle1"
               color="inherit"
               className={classes.imageTitle}
             >
               {image.title}
               <span className={classes.imageMarked} />
             </Typography>
           </span>
         </ButtonBase>
       ))}
       
     </div>
     
   );
            }else
            {
              return (
                <div className="container">
                  <header className="jumbotron">
                    <h3>{content}</h3>
                  </header>
                </div>
              );
            }
}


export default BoardUser;